<template>
  <DoctorSpecialityModal
    :value="isDialogOpened"
    @input="handleCloseModal"
  >
    <template #footer>
      <BtnApplyFilters
        :active="isDialogOpened"
        class="pa-2 elevation-8"
        @click:submit="applySelectedDoctorSpeciality"
        @click:close="closeDialog"
      />
    </template>
  </DoctorSpecialityModal>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import I18NextVue from 'i18next'
import { dispatchCustomEventGlobally } from 'www/utils'
import useChipsStore from 'www/vue_components/common/TheFilters/lpu/stores/useChipsStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import updateLpuListPage from 'www/vue_components/common/TheFilters/lpu/functions/updateLpuListPage'
import BtnApplyFilters from 'www/vue_components/common/TheFilters/lpu/components/BtnApplyFilters/BtnApplyFilters.vue'
import DoctorSpecialityModal from 'www/vue_components/common/TheFilters/lpu/components/DoctorSpecialityFilters/components/DoctorSpecialityModal.vue'
import { EVENTS as SNACKBAR_EVENTS } from 'www/vue_components/common/core/SnackbarNotification/constants'

const chipsStore = useChipsStore()
const filtersStore = useFiltersStore()

const { isDialogOpened, openDialog, closeDialog } = useDialogManager('DoctorSpeciality')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

watch(
  () => filtersStore.filters.doctorSpeciality,
  () => {
    chipsStore.updateDoctorSpecialityChip({
      name: filtersStore.filters.doctorSpeciality?.name || t('Специальность врача', options.value),
      isActive: !!filtersStore.filters.doctorSpeciality,
      dropdown: !filtersStore.filters.doctorSpeciality,
      truncate: true,
      isVisible: true,
      onClick: openDialog,
      onReset: async () => {
        filtersStore.updateFilters({ doctorSpeciality: undefined })

        await updateLpuListPage()

        dispatchCustomEventGlobally(SNACKBAR_EVENTS.open, {
          upper: true,
          message: t('Фильтр сброшен', options.value),
        })
      },
    })
  },
  { immediate: true },
)

function applySelectedDoctorSpeciality() {
  closeDialog()
  filtersStore.applyUnsavedFilters()
  updateLpuListPage()
}

function handleCloseModal() {
  closeDialog()
  filtersStore.resetUnsavedFilters()
}
</script>
